import _ from 'lodash';
import { useEffect } from 'react';
import storage from '$lib/storage';
import logger from '$lib/logger';

const STAGE = process.env.STAGE; // eslint-disable-line prefer-destructuring

export const identify = (user) => {
  try {
    const { isImpersonated } = storage.getAuth();
    if ((STAGE === 'production' || STAGE === 'uat') && user && !isImpersonated) {
      const { uuid: userUuid, email, subscriptions } = user;

      const subscriptionProductSlugs = _.map(subscriptions, 'product.slug');

      const userProperties = {
        email,
        subscriptionProductSlugs,
      };

      if (window.amplitude) {
        window.amplitude.getInstance().setUserId(userUuid);
        window.amplitude.getInstance().setUserProperties(userProperties);
      }

      if (window.FS) {
        window.FS.identify(userUuid, userProperties);
      }

      if (window.heap) {
        window.heap.identify(userUuid);
        window.heap.addUserProperties(userProperties);
      }
    }
  } catch (e) {
    logger.error(e);
  }
};

export const track = (eventName, properties) => {
  logger.info(`Track: ${eventName} | ${JSON.stringify(properties)}`);
  try {
    if (window.heap) {
      window.heap.track(eventName, properties);
    }
    if (window.amplitude) {
      window.amplitude.getInstance().logEvent(eventName, properties);
    }
  } catch (e) {
    logger.error(e);
  }
};

export const useTrack = (eventName, properties, deps = []) => {
  useEffect(() => {
    track(eventName, properties);
  }, deps);
};

export const trackSignUp = ({ userUuid, skipAffiliate, sourcePage }) => {
  if (STAGE === 'production') {
    const value = 1;

    if (window.fbq) {
      window.fbq('track', 'CompleteRegistration', {
        value,
        currency: 'USD',
      });
    }

    if (window.gtag) {
      window.gtag('event', 'sign_up');
      window.gtag('event', 'conversion', {
        send_to: 'AW-847304068/tspgCKTooc4BEISrg5QD',
      });
    }

    if (window.rdt) {
      window.rdt('track', 'SignUp');
    }

    if (window.qp) {
      window.qp('track', 'CompleteRegistration');
    }

    // 20200617JP: This seems to be enough to get it to load; no need to attach to DOM.
    const linkedInPixel = new Image(1, 1);
    linkedInPixel.src =
      'https://px.ads.linkedin.com/collect/?pid=2306836&conversionId=2607156&fmt=gif';
  }

  track('User | Created', { sourcePage });

  if (STAGE === 'production') {
    if (!skipAffiliate) {
      try {
        window.PostAffTracker.setAccountId('default1');
        const action = window.PostAffTracker.createAction('signUp');
        action.setOrderID(userUuid);
        window.PostAffTracker.register();
      } catch (e) {
        logger.error(e);
      }
    }
  }
};
